import { Calculation } from 'final-form-calculate'
import { ProcedimentosAutomaticosAtendimentoIndividual } from 'types/enums'
import { emptyArray } from 'util/array'
import { MetaPath } from 'util/metaPath'
import { SoapState } from 'view/atendimentos/atendimento-individual/model'
import { MedicoesPanelModel } from 'view/atendimentos/components/MedicoesPanel/MedicoesPanel'
import { ProcedimentoAutomatico } from 'view/atendimentos/model-atendimento'
import {
  addOrRemoveAfericaoPressaoArterial,
  addOrRemoveAfericaoTemperatura,
  addOrRemoveGlicemiaCapilar,
} from 'view/atendimentos/utils/util-procedimentoAutomatico'

import { PlanoFormModel } from './PlanoForm'

export interface HasAccessProcedimentos {
  desenvolvimentoCrianca: boolean
  crescimentoCrianca: boolean
  glicemiaCapilar: boolean
}

export const createPlanoMedicoesCalculations = (
  plano: MetaPath<PlanoFormModel>,
  medicoes: MetaPath<MedicoesPanelModel>,
  procedimentosAutomaticos: ProcedimentoAutomatico[],
  hasAccessProcedimentos: HasAccessProcedimentos
): Calculation[] => [
  {
    field: [medicoes.pressaoArterialSistolica.absolutePath(), medicoes.pressaoArterialDiastolica.absolutePath()],
    updates: {
      [plano.intervencoesProcedimentos.procedimentosPlano.procedimentos.absolutePath()]: (_, allValues: SoapState) => {
        const medicoes = allValues?.objetivo?.medicoes

        const listaProcedimentos =
          allValues.plano?.intervencoesProcedimentos?.procedimentosPlano?.procedimentos ?? emptyArray
        const codigosProcedimentosAutomaticosExcluidos =
          allValues.plano?.intervencoesProcedimentos?.procedimentosPlano?.codigosProcedimentosAutomaticosExcluidos ??
          emptyArray

        return addOrRemoveAfericaoPressaoArterial(
          medicoes?.pressaoArterialSistolica,
          medicoes?.pressaoArterialDiastolica,
          listaProcedimentos,
          procedimentosAutomaticos,
          codigosProcedimentosAutomaticosExcluidos,
          ProcedimentosAutomaticosAtendimentoIndividual.AFERICAO_PRESSAO_ARTERIAL
        )
      },
    },
  },
  {
    field: medicoes.glicemia.absolutePath(),
    updates: {
      [plano.intervencoesProcedimentos.procedimentosPlano.procedimentos.absolutePath()]: (_, allValues: SoapState) => {
        const listaProcedimentos =
          allValues.plano?.intervencoesProcedimentos?.procedimentosPlano?.procedimentos ?? emptyArray
        const codigosProcedimentosAutomaticosExcluidos =
          allValues.plano?.intervencoesProcedimentos?.procedimentosPlano?.codigosProcedimentosAutomaticosExcluidos ??
          emptyArray

        return addOrRemoveGlicemiaCapilar(
          allValues.objetivo?.medicoes?.glicemia,
          hasAccessProcedimentos.glicemiaCapilar,
          listaProcedimentos,
          procedimentosAutomaticos,
          codigosProcedimentosAutomaticosExcluidos,
          ProcedimentosAutomaticosAtendimentoIndividual.GLICEMIA_CAPILAR
        )
      },
    },
  },
  {
    field: medicoes.temperatura.absolutePath(),
    updates: {
      [plano.intervencoesProcedimentos.procedimentosPlano.procedimentos.absolutePath()]: (_, allValues: SoapState) => {
        const listaProcedimentos =
          allValues.plano?.intervencoesProcedimentos?.procedimentosPlano?.procedimentos ?? emptyArray
        const codigosProcedimentosAutomaticosExcluidos =
          allValues.plano?.intervencoesProcedimentos?.procedimentosPlano?.codigosProcedimentosAutomaticosExcluidos ??
          emptyArray

        return addOrRemoveAfericaoTemperatura(
          allValues.objetivo?.medicoes?.temperatura,
          listaProcedimentos,
          procedimentosAutomaticos,
          codigosProcedimentosAutomaticosExcluidos,
          ProcedimentosAutomaticosAtendimentoIndividual.AFERICAO_DE_TEMPERATURA
        )
      },
    },
  },
]
